import { render, staticRenderFns } from "./ListMenu.vue?vue&type=template&id=5d5390ee&scoped=true"
import script from "./ListMenu.vue?vue&type=script&lang=js"
export * from "./ListMenu.vue?vue&type=script&lang=js"
import style0 from "./ListMenu.vue?vue&type=style&index=0&id=5d5390ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5390ee",
  null
  
)

export default component.exports